/**
 * Considera bloccanti solo gli errori 5XX
 */
export function getBlockingError<
  TError extends { response?: { status?: number } },
>(error: TError | null | undefined): TError | undefined {
  return error?.response?.status && error.response.status >= 500
    ? error
    : undefined;
}
